import { WEEKDAYS } from '@/constants/weekdays'

const JS_SUNDAY_INDEX = 0
const LAST_WEEKDAY_OBJ = WEEKDAYS[WEEKDAYS.length - 1]
const FRIENDLY_FIRE_SUNDAY_INDEX = LAST_WEEKDAY_OBJ.value

export function convertNativeJsToFriendlyFireWeekdayIndex(
  jsWeekDayIndex: number,
): number {
  if (jsWeekDayIndex === JS_SUNDAY_INDEX) return FRIENDLY_FIRE_SUNDAY_INDEX
  return jsWeekDayIndex - 1
}
